import { render, staticRenderFns } from "./PaginationStyle1.vue?vue&type=template&id=71f70a17"
import script from "./PaginationStyle1.vue?vue&type=script&lang=js"
export * from "./PaginationStyle1.vue?vue&type=script&lang=js"
import style0 from "./PaginationStyle1.vue?vue&type=style&index=0&id=71f70a17&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports